// @flow

import React, { type Node } from 'react';
import styled, { type StyledComponent } from 'styled-components';

import type { Pet } from '@rover/react-lib/types';
import { Paragraph } from '@rover/react-lib/components/typography';
import FormGroup from '@rover/react-lib/components/formFields/FormGroup';
import Textarea from '@rover/react-lib/components/formFields/Textarea';
import Button, { ButtonType } from '@rover/react-lib/components/buttons/Button';
import { CareInstructionsConstants } from '@rover/app/js/constants/translationConstants';

type Props = {
  pet: Pet,
  hasMultiplePets: boolean,
  handleCareInstructionsChange: (careInstructions: string) => void,
  value: string,
  isEditing: boolean,
  toggleEditing: (pet: Pet) => void,
};

const UpdateButton: StyledComponent<{}> = styled(Button)`
  padding: 0;
`;

const CareInstruction = ({
  pet,
  hasMultiplePets,
  handleCareInstructionsChange,
  value,
  isEditing,
  toggleEditing,
}: Props): Node => {
  const inputId = `care-instructions-${pet.id}`;

  return (
    <FormGroup>
      {hasMultiplePets && <label htmlFor={inputId}>{pet.name}</label>}
      {isEditing ? (
        <Textarea autoExpand onChange={handleCareInstructionsChange} value={value} id={inputId} />
      ) : (
        <Paragraph marginBottom="1x">{value}</Paragraph>
      )}

      {!isEditing && (
        <UpdateButton buttonType={ButtonType.TEXT} onClick={() => toggleEditing(pet)}>
          {CareInstructionsConstants.updateButton}
        </UpdateButton>
      )}
    </FormGroup>
  );
};

export default CareInstruction;



// WEBPACK FOOTER //
// ../react-lib/src/pages/conversations/EmergencyFormPage/components/CareInstructions/CareInstruction.jsx